import { render, staticRenderFns } from "./notes.vue?vue&type=template&id=a90232f8&scoped=true"
import script from "./notes.vue?vue&type=script&lang=js"
export * from "./notes.vue?vue&type=script&lang=js"
import style0 from "./notes.vue?vue&type=style&index=0&id=a90232f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a90232f8",
  null
  
)

export default component.exports